import { useContext } from 'react';
import { CollapseDrawerContext } from '../contexts';
import { CollapseDrawerContextProps } from '../contexts/collapseDrawer/types';

// eslint-disable-next-line max-len
export const useCollapseDrawer = (): CollapseDrawerContextProps => useContext(CollapseDrawerContext);
